import { render, staticRenderFns } from "./LoanDetail.vue?vue&type=template&id=31e7c536&scoped=true"
import script from "./LoanDetail.vue?vue&type=script&lang=js"
export * from "./LoanDetail.vue?vue&type=script&lang=js"
import style0 from "./LoanDetail.vue?vue&type=style&index=0&id=31e7c536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e7c536",
  null
  
)

export default component.exports